import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../../components/buttons/button";
import { TextInput } from "../../../../components/inputs/textInput";
import { InfoComponent } from "../../../../components/notification/infoComponent";
import { AuthHeader } from "../../../../components/typography/authHeader";
import { BaseApiErrorResponse } from "../../../../utils/types";
import { SignInSchema } from "../../../../utils/validations";
import { authSliceActions } from "../../../../redux/features/auth/auth.slice";
import { useAppDispatch } from "../../../../redux/hooks";
import { useSalesLoginMutation } from "../../../../redux/features/sales/auth/auth.api";

export const SalesLoginPage = () => {
  const [login, { isLoading, isError, error }] = useSalesLoginMutation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { values, handleBlur, handleChange, handleSubmit, errors, touched } =
    useFormik({
      initialValues: {
        email: "",
        password: "",
      },
      validationSchema: SignInSchema,
      onSubmit: async (vals) => {
        const response = await login({
          email: vals.email,
          password: vals.password,
        });

        if (response.data?.status === "success") {
          dispatch(
            authSliceActions.signSalesIn({
              profile: {
                ...response.data.data,
              },
              token: response.data.data.token,
            }),
          );
          navigate("/dashboard");
        }
      },
    });

  return (
    <form
      className="w-full rounded-2xl bg-white px-5 py-16 md:p-8"
      onSubmit={handleSubmit}
    >
      <AuthHeader
        header={"Sales Login"}
        text={<span>Welcome to Tikket Sales Dashboard.</span>}
      />

      <div className="mt-10 flex flex-col gap-5">
        {isError && (
          <InfoComponent
            title="Error"
            text={
              (error as unknown as BaseApiErrorResponse)?.data?.message ??
              "An error occurred!"
            }
            type="error"
          />
        )}

        <TextInput
          type="text"
          name="email"
          value={values.email}
          placeholder="e.g. example@email.com"
          onChange={handleChange}
          onBlur={handleBlur}
          hasTitle
          title="Email"
          errors={errors.email && touched.email ? errors.email : ""}
          autoFocus
          autoFocusOnMobile={false}
        />

        <TextInput
          type="password"
          name="password"
          value={values.password}
          placeholder="Enter your password"
          onChange={handleChange}
          onBlur={handleBlur}
          hasTitle
          title="Password"
          errors={errors.password && touched.password ? errors.password : ""}
        />
        <Link
          to={`/forgot-password${!errors.email ? `?email=${encodeURIComponent(values.email)}` : ""}`}
          className="text-sm font-bold text-grey-700"
        >
          Forgot Password?
        </Link>
        <Button
          type="submit"
          text="Login"
          variation="primary"
          className="mt-5"
          loading={isLoading}
          disabled={isLoading}
        />
      </div>
    </form>
  );
};
